import { CheckoutPause } from '../../api/components/checkout-pause';

export function getCheckoutPauseMessage(checkoutPause: CheckoutPause | null, language: string): string {
  if (!checkoutPause?.enabled) {
    return '';
  }

  const lang = (language || 'de').split('-')[0].toLowerCase();
  return lang === 'en' ? checkoutPause.message.en : checkoutPause.message.de;
}
